<template>
  <div class="license-con">
    <div class="layout-license">
      <h1 class="license-title">百布用户服务协议（供应商）</h1>
      <p class="license-item">本协议是您（或称“用户”）与百布（简称“本App”）所有者广州百景信息科技服务有限公司（以下简称为“百景公司”）
        之间就本App服务等相关事宜所订立的协议，请您仔细阅读本注册协议，您勾选“同意”按钮后，本协议即生效并对双方具有约束力。
      </p>
      <p class="license-item">第1条 本App服务条款的确认和接纳</p>
      <ol class="license-list">
        <li>1.1本App的各项在线服务的所有权和运作权归百景公司所有。用户同意所有注册协议条款并完成注册程序，才能成为本App的正式用户。
          用户确认：本协议条款是处理双方权利义务的协议，始终有效，法律另有规定或双方另有特别约定的，依其规定。
        </li>
        <li>1.2用户点击同意本协议，即视为用户确认自己具有享受在线购买面料、辅料及享受服务等相应的权利和行为能力，能够独立承担法律责任。</li>
        <li>1.3百景公司保留在中华人民共和国大陆地区法施行之法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容或取消订单的权利。</li>
      </ol>
      <p class="license-item">第2条 本App服务</p>
      <p class="license-item">本App为信息服务平台，百景公司通过本App及互联网依法为用户提供面料、辅料产品信息，
        用户在完全同意本协议及本App规定的情况下，方有权使用本App的相关服务。
      </p>
      <p class="license-item">第3条 用户信息</p>
      <ol class="license-list">
        <li>3.1用户应本着个人或企业诚信向本App提供注册资料，用户同意其提供的注册资料真实、准确、完整、合法有效，用户注册资料如有变动的，
          应及时更新其注册资料。如果用户提供的注册资料不合法有效、不真实、不准确、不详尽的，用户需承担因此引起的相应责任及后果，并且百景公司保留终止用户使用本App各项服务的权利。
        </li>
        <li>3.2用户在本App进行浏览、下单定货等活动时，涉及用户真实姓名/名称、通信地址、联系方式、营业执照等隐私信息的，本App将予以严格保密，
          除非得到用户授权或法律另有规定，本App不会向外界披露用户隐私信息。
        </li>
        <li>3.3用户注册成功后，将产生密码等账户信息，您可以根据本App提示修改您的密码。用户应谨慎合理的保存、使用其密码。
          用户若发现任何非法使用用户账号或存在安全漏洞的情况，请立即通知本App。否则，由于用户自身的疏忽而导致账号信息泄露等后果，由用户自行承担。
        </li>
        <li>3.4用户同意，百景公司拥有通过邮件、短信、电话等形式，向在本App注册、购物的用户发送订单信息、促销活动等告知信息的权利。</li>
        <li>3.5用户若将在本App注册获得的账户借给他人使用，则必须承担由此产生的全部责任，且实际使用人需承担连带责任。</li>
        <li>3.6用户同意，百景公司有权使用用户的注册信息、密码等信息，登陆进入用户的注册账户，进行证据保全，包括但不限于公证、见证等。</li>
      </ol>
      <p class="license-item">第4条 账户说明</p>
      <ol class="license-list">
        <li>4.1您应对您的手机号和密码的安全，以及对通过其手机号和密码实施的行为负责。您在本App注册的手机号和密码仅限于您自身内部人员进行使用，
          不得给予任何第三方使用，否则由此造成的损失由您自行承担，且百景公司保留暂停或终止服务。
        </li>
        <li>4.2您遗忘或丢失在本App注册的密码时，可与本App客户服务人员取得联系，在提供相关证明资料并经百景公司审核确认后，可找回密码。</li>
      </ol>
      <p class="license-item">第5条 信息的修改</p>
      <p class="license-item">您注册本App账号后，如相应信息发生变更，您必须及时、主动联系百景公司或本App客户服务人员进行更新。
        因您未及时更新，造成您不能享受相关服务的、或造成账号及密码泄露等所有责任由您自行承担。
      </p>
      <p class="license-item">第6条 用户依法言行义务</p>
      <p class="license-item">本协议依据国家相关法律法规规章制定，用户同意严格遵守以下义务：</p>
      <ol class="license-list">
        <li>（1）不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、
          破坏国家统一的的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；
        </li>
        <li>（2）从中国大陆向境外传输资料信息时必须符合中国有关法规；</li>
        <li>（3）不得利用本App从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；</li>
        <li>（4）不得干扰本App的正常运转，不得侵入本App及国家计算机信息系统；</li>
        <li>（5）不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；</li>
        <li>（6）不得教唆他人从事本条款所禁止的行为；</li>
        <li>（7）不得利用在本App注册的账户进行非法牟利经营活动；用户应不时关注并遵守本App不时公布或修改的各类合法规则规定。
          本App保有删除站内各类不符合法律政策或不真实的信息内容而无须通知用户的权利。若用户未遵守以上规定的，
          本App有权作出独立判断并采取暂停或关闭用户帐号等措施。用户须对自己在网上的言论和行为承担法律责任。
        </li>
      </ol>
      <p class="license-item">第7条 商品信息</p>
      <p class="license-item">本App上的货物价格、数量、是否有货等商品信息将根据市场行情及销售情况随时发生变动，本App不作特别通知。
        由于本App货物信息数量庞大，虽然本App会尽最大努力保证您所浏览商品信息的准确性，但由于网络及手机终端兼容性等客观原因存在，
        本App显示的信息可能会有一定的滞后性或差错，对此情形请您知悉并理解；本App欢迎纠错，并会视情况给予纠错者一定的奖励。
      </p>
      <p class="license-item">第8条 下单订货</p>
      <ol class="license-list">
        <li>8.1您在本App下订单时，请您仔细确认所购货物的品名、价格、数量、材质、规格等信息。若您提供的信息错误导致交易过程中出现利益损失的，
          则百景公司将不承担相应法律责任及连带责任。
        </li>
        <li>8.2用户应在下单后在本App规定的时限内向百景公司指定的银行账户支付货款。为了保障用户的合法权益，避免交易风险，用户在付款前，请仔细核对账户信息。</li>
        <li>8.3除法律另有强制性规定外，双方约定如下：本App展示的商品和价格等信息仅仅是百景公司的要约邀请，
          您下单时须填写您希望购买的商品数量、规格、收货方式等内容；系统生成的订单信息是计算机信息系统根据您填写的内容自动生成的数据，
          仅是您向百景公司发出的合同要约；百景公司收到您的订单信息，并收到您向百景公司指定账户支付的货款后，即视为您与百景公司之间建立了委托服务合同关系；
          百景公司将根据相应约定由百景公司或其它第三方向您递送货物；
        </li>
        <li>8.4由于市场变化及各种以合理商业努力难以控制的因素的影响，百景公司或本App无法保证您提交的订单信息中希望购买的商品都会有货；
          如您拟购买的商品，发生缺货，您有权取消订单。
        </li>
        <li>8.5用户的货款由百布平台代为收取，并受用户指令支付给相应供应商。</li>
      </ol>
      <p class="license-item">第9条 收货</p>
      <ol class="license-list">
        <li>9.1您在完成支付后，即可根据具体情况采取以下方式收取货物：</li>
        <li>（1）百景公司或合作供应商直接寄至您提供的地址；</li>
        <li>（2）您亲自至百景公司或合作供应商处提取货物。</li>
        <li>9.2因如下情况造成无法收货等，百景公司及合作供应商不承担任何责任：</li>
        <li>（1）用户提供的寄送信息错误导致的；</li>
        <li>（2）情势变更因素导致的；</li>
        <li>（3）不可抗力因素导致的，例如：自然灾害、交通戒严、突发战争等。</li>
      </ol>
      <p class="license-item">第10条 责任限制及不承诺担保</p>
      <p class="license-item">除非另有明确的书面说明，本App及其所包含的或以其它方式通过本App提供给您的全部信息、资料、货物（包括软件）和服务，
        均是在“按现状”和“按现有”的基础上提供的。除非另有明确的书面说明，百景公司不对本App的运营及其包含在本App上的信息、资料、货物（包括软件）
        和服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。
        如因不可抗力或其它本App无法控制的原因使本App销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，百景公司会合理地尽力协助处理善后事宜。
        百布平台仅为交易信息发布及撮合交易平台，就交易订立及履行过程中发生的任何争议（包括但不限于货物数量、质量等）不承担任何赔偿责任。
      </p>
      <p class="license-item">第11条 协议更新及用户关注义务</p>
      <ol class="license-list">
        <li>11.1根据国家法律法规变化及App运营需要，百景公司有权对本协议条款不时地进行修改，修改后的协议一旦被张贴在本App或百景公司相关平台上即生效，
          并代替原来的协议。用户可随时登陆查阅最新协议；用户有义务不时关注并阅读最新版的协议及本App公告。
          如用户不同意更新后的协议，可以且应立即停止接受百景公司依据本协议提供的服务；如用户继续使用本App提供的服务的，即视为同意更新后的协议。
          百景公司建议您在使用本App之前阅读本协议及本App的公告。如果本协议中任何一条被视为废止、无效或因任何理由不可执行，
          该条应视为可分的且并不影响任何其余条款的有效性和可执行性。
        </li>
        <li>11.2任何经百景公司确认已经违反相关法律法规或本协议或本App使用规则某一项或多项规定的用户，百景公司有权决定是否给予暂停使用或终止使用的处理，
          且因此造成的一切后果由用户自行承担。
        </li>
        <li>11.3用户与百景公司基于交易合作签署的其他书面协议与本协议不一致的，以双方书面签署的协议为准。</li>
      </ol>
      <p class="license-item">第12条 法律管辖和适用</p>
      <p class="license-item">本协议的订立、执行和解释及争议的解决均应适用在中华人民共和国大陆地区适用之有效法律（但不包括其冲突法规则）。
        如发生本协议与适用之法律相抵触时，则这些条款将完全按法律规定重新解释，而其它有效条款继续有效。
        如缔约方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向有管辖权的中华人民共和国大陆地区法院提起诉讼。
      </p>
      <p class="license-item">第13条 其他</p>
      <ol class="license-list">
        <li>13.1本App所有者是指在政府部门依法许可或备案的本App经营主体。</li>
        <li>13.2百景公司尊重用户和消费者的合法权利，本协议及本App上发布的各类规则、声明等其他内容，均是为了更好的、更加便利的为用户和消费者提供服务。
          本App欢迎用户和社会各界提出意见和建议，百景公司将虚心接受并适时修改本协议及本App上的各类规则。
        </li>
      </ol>
    </div>

  </div>
</template>

<script>
export default {
  name: 'BaibuLicense',
  data() {
    return {};
  },

  created() {

  },

  mounted() {

  },

  computed: {},

  components: {},

  methods: {},
};
</script>

<style scoped lang="scss">
  .license-con{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    color: #000000;
    background: #F8F8F8;
    overflow-y: auto;
  }
  .layout-license {
    padding: 0 20px 20px 20px;
    font-size: 14px;
    background: #FFFFFF;
    margin: 15px;
    border: 1px solid #FFFFFF;
    box-shadow:0 8px 16px 0 rgba(0, 0, 0, 0.06);
    border-radius:8px;
  }
  .license-title {
    font-size:20px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:28px;
    margin: 25px 0;
    text-align: left;
  }
  p.license-item {
    margin: 0;
    font-size:14px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:24px;
  }
  ol.license-list {
    list-style-type: none;
    margin: 0;
    padding: 0;
    color: #333333;
  }
  ol.license-list li {
    list-style-type: none;
    margin: 0;
    line-height: 24px;
    color: #333333;
  }
</style>
